var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.481161 0.364375L0.538652 0.28376C0.749449 0.0285841 1.0793 0.00539251 1.31175 0.214165L1.37834 0.28376L6.50016 6.48353L11.622 0.28376C11.8539 0.00307325 12.2298 0.00307325 12.4616 0.28376C12.6935 0.564446 12.6935 1.01954 12.4616 1.30023L7.34012 7.50033L12.4616 13.7005C12.6725 13.9556 12.6916 14.3549 12.5191 14.6363L12.4616 14.7169C12.2509 14.9721 11.921 14.9953 11.6886 14.7864L11.622 14.7169L6.50016 8.51712L1.37834 14.7169C1.14647 14.9976 0.770523 14.9976 0.538652 14.7169C0.30678 14.4362 0.30678 13.9812 0.538652 13.7005L5.6602 7.50033L0.538652 1.30023C0.327855 1.04505 0.308696 0.645751 0.481161 0.364375Z",
    fill: "#545565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel_icon.e67db0895e9e96fea524126d3aabdb53.svg";
export { ForwardRef as ReactComponent };